import { render, staticRenderFns } from "./prizeset.vue?vue&type=template&id=81199586&"
import script from "./prizeset.vue?vue&type=script&lang=js&"
export * from "./prizeset.vue?vue&type=script&lang=js&"
import style0 from "./prizeset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports